import './FaqButton.scss'
import * as React from 'react'
import { observer } from 'mobx-react'

const FaqButton = () => {
    const [language, setLanguage] = React.useState("")

    React.useEffect(() => {
        const userLanguage = localStorage.getItem('userLanguage')
        setLanguage(userLanguage)
    }, [])

    return (
        language === 'Svenska'
            ? <a href='https://tofindout.se/sv/allt-du-som-kandidat-behover-veta-om-bakgrundskontroller/' target='_blank' className={'FaqButton'} />
            : <a href='https://tofindout.se/en/all-you-need-to-know-about-background-checks-as-a-candidate/' target='_blank' className={'FaqButton'} />
    )
}

export default observer(FaqButton)